import { FC } from 'react'
import { useSelector } from 'react-redux'
import { StickyContainer } from 'react-sticky-17'
import useFooter from 'src/hooks/useFooter'
import { formatFooterLinks } from 'src/utils/FormatUtils'

import useGeneratingPlanning from '../../hooks/useGeneratingPlanning'
import { selectors } from '../../redux'
import Header from '../../components/Header'
import GeneratingPlanning from '../../templates/GeneratingPlanning'
import Seo, { SeoProps } from '../../components/Seo'
import useApplication from '../../hooks/useApplication'
import Footer from '../../components/Footer'
import Pwa from '../../components/Pwa'
import useSEO from '../../hooks/useSEO'
import usePWA from '../../hooks/usePWA'
import { app } from '../../configuration'
import useLoadingProps from '../../hooks/useLoadingProps'

import * as SC from './styled'

export type DefaultLayoutProps = {
  children: JSX.Element
  seoProps?: SeoProps
}

const DefaultLayout: FC<DefaultLayoutProps> = ({ children, seoProps }) => {
  const { headerProps } = useApplication()
  const footerData = useSelector(selectors.app.footerData)
  const { generatingPlanningProps } = useGeneratingPlanning()
  const { loadingProps } = useLoadingProps()
  const isGeneratingPlanning = useSelector(selectors.user.isGeneratingPlanning)
  const isLoading = useSelector(selectors.app.isLoading)
  const pwa = usePWA()
  const seo = { ...useSEO(), ...seoProps }

  return (
    <>
      <Seo {...seo} />
      {app.USE_PWA && <Pwa {...pwa} />}
      {headerProps && <Header {...headerProps} />}
      <SC.Layout>
        <StickyContainer>
          {isGeneratingPlanning && generatingPlanningProps && (
            <GeneratingPlanning {...generatingPlanningProps} />
          )}
          {isLoading && <GeneratingPlanning {...loadingProps} />}
          {!isGeneratingPlanning && !isLoading && children}
        </StickyContainer>
      </SC.Layout>
      <Footer
        {...useFooter()}
        menu={formatFooterLinks(footerData?.menu)}
        legals={footerData?.legals}
      />
    </>
  )
}

export default DefaultLayout
